var _style, _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSortByIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;}\r\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#0D3151;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M63.1,1.9h24v24h-24V1.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M93.5,4.3h24v24h-24V4.3z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M16.7,7.4v9.2h-1.8c-0.5,0-0.7,0.5-0.4,0.9l2.8,2.8c0.2,0.2,0.5,0.2,0.7,0l2.8-2.8c0.3-0.3,0.1-0.9-0.3-0.9 h-1.8V7.4h1.8c0.4,0,0.7-0.5,0.4-0.8l-2.8-2.8c-0.2-0.2-0.5-0.2-0.7,0l-2.8,2.8c-0.3,0.3-0.1,0.8,0.4,0.8H16.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5,16.6h-1.8v-3.2c0,0,0,0,0,0v-6h1.8c0.4,0,0.7-0.5,0.3-0.8l-2.8-2.8c-0.2-0.2-0.5-0.2-0.7,0l-2.8,2.8 c-0.3,0.3-0.1,0.8,0.4,0.8h1.8v3.2c0,0,0,0,0,0v6h-1.8c-0.4,0-0.7,0.5-0.3,0.9l2.8,2.8c0.2,0.2,0.5,0.2,0.7,0l2.8-2.8 C21.2,17.2,20.9,16.6,20.5,16.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,17c0,0.5-0.4,1-1,1H4c-0.5,0-1-0.5-1-1s0.5-1,1-1h4C8.6,16,9,16.4,9,17z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7,11v2H4c-0.5,0-1-0.5-1-1s0.5-1,1-1H12.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5,8H4C3.5,8,3,7.5,3,7s0.5-1,1-1h6.5C10.3,6.7,10.4,7.4,10.5,8z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortByIcon);
export default __webpack_public_path__ + "static/media/SortByIcon.063a486ce7249413b08940c2f83f3e13.svg";
export { ForwardRef as ReactComponent };